import {
  useTheme
} from "./chunk-JVDTBYWX.js";
import {
  navbarTheme
} from "./chunk-C2SK4YPI.js";

// src/components/navbar.tsx
import * as React from "react";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
function NavbarRoot({ as, color, variant, className, children, ...props }, ref) {
  const Component = as || "nav";
  const contextTheme = useTheme();
  const theme = contextTheme.navbar || navbarTheme;
  const defaultProps = theme.defaultProps;
  color ??= defaultProps?.color ?? "default";
  variant ??= defaultProps?.variant ?? "solid";
  const styles = twMerge(
    theme.baseStyle,
    theme.variant[variant][color],
    className
  );
  return /* @__PURE__ */ jsx(Component, { ...props, ref, className: styles, children });
}
NavbarRoot.displayName = "MaterialTailwind.Navbar";
var Navbar = React.forwardRef(NavbarRoot);
var navbar_default = Navbar;

export {
  Navbar,
  navbar_default
};
